import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { ToursApiService } from './services/tours-api.service';
import { ToursSearchFormService } from './services/tours-search-form.service';
import { ToursState } from './state/tours.state';

export const toursPageRouteConfig: Route = {
  path: 'tours',
  loadComponent: () => import('./tours-page.component').then((c) => c.ToursPageComponent),
  providers: [provideStates([ToursState]), ToursApiService, ToursSearchFormService]
};
